// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"361d9560","191":"5d6ee97e","262":"98dcdefe","318":"0dcb91cb"}[chunkId] + ".chunk.css";
};